var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content" },
    [
      _vm.assetReservationObjects && _vm.assetReservationObjects.length > 0
        ? _c(
            "v-expansion-panels",
            _vm._l(_vm.assetReservationObjects, function(
              assetReservationObject,
              objectIndex
            ) {
              return _c(
                "v-expansion-panel",
                { key: objectIndex, staticStyle: { margin: "0 20px" } },
                [
                  _c("asset-reservation-object-panel", {
                    attrs: {
                      "object-uuid": _vm.objectUuid,
                      "original-asset-reservation-object": assetReservationObject,
                      disabled: _vm.disabled,
                      fields: _vm.fields
                    },
                    on: {
                      "update-loading": function($event) {
                        _vm.loading = $event
                      },
                      "update-asset-reservation-object": function($event) {
                        _vm.assetReservationObjects[objectIndex] = $event
                      },
                      "delete-asset-reservation-object": function($event) {
                        return _vm.assetReservationObjects.splice(
                          objectIndex,
                          1
                        )
                      }
                    }
                  })
                ],
                1
              )
            }),
            1
          )
        : _c(
            "v-layout",
            {
              staticStyle: { height: "100px" },
              attrs: { row: "", "justify-center": "", "align-center": "" }
            },
            [
              _c("div", { staticClass: "message" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("NoAssetReservationsAssociatedWithObject")) +
                    "\n    "
                )
              ])
            ]
          ),
      _vm._v(" "),
      _c("loading-spinner", {
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "accent",
          "background-color": "transparent"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-311eb988", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-311eb988","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/AssetReservationTab/AssetReservationTab.vue
// module id = null
// module chunks = 